export enum AssessmentKeys {
  getAllAssessment = "get-all-assessment",
  getAssessment = "get-assessment",
  createAssessment = "create-assessment",
  gradeAssessment = "grade-assessment",
}
